import * as _ from 'lodash';
import { deburrAndLower } from 'helpers';

export function sortByName<T extends { name: string }>(array: T[]): T[] {
    return _.sortBy(array, ({ name }) => deburrAndLower(name));
}

export function sortBy<T>(array: T[], fieldPath): T[] {
    return _.sortBy(array, (item) => {
        const field = _.get(item, fieldPath);
        return deburrAndLower(field);
    });
}

export function sortObjectToQueryString(sort: Record<string, string>) {
    let output = '';

    if (sort.sortBy && sort.sortDirection) output = `${sort.sortBy}:${sort.sortDirection}`;

    return output;
}
